var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart chart-sample_graph"},[_c('apexchart',{attrs:{"height":"324px","series":_vm.series,"options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }